import { genElZirvuImage } from "../../../../components/utils/EditorDialogElementGenerator";
import { getFotoFolderName } from "../../utils/editorHelpers";

// Photo of a checklist row. It is never shown: pressing "Foto" in the row popover presses the "Take Photo" button
// of this genElZirvuImage (see useEditorNote.handleOnClickFoto).
// genElZirvuImage uploads the photo to the file manager and gives back its url; that url (or "" when the photo
// is cleared) is handed to onChangeFoto, which saves the row.
//   fotoTargetRef: { row } of the photo that is being taken
const EditorFotoUploader = ({
  uploaderRef,
  fotoTargetRef,
  headerData,
  pengecekanDetilData,
  onChangeFoto,
}) => {
  const folderName = getFotoFolderName(headerData);

  const elFoto = genElZirvuImage({
    field: "gambar",
    name: "Foto",
    folderName,
    data: { gambar: null },
    setData: (newData) => {
      const target = fotoTargetRef.current;
      if (!target) return;

      const detil = pengecekanDetilData.find((el) => el.id === target.row.id);
      if (!detil) return;

      const current = { gambar: detil.gambar };
      const resolved = typeof newData === "function" ? newData(current) : newData;
      onChangeFoto({ detil, gambar: resolved.gambar });
    },
    error: {},
  });

  return (
    <div ref={uploaderRef} style={{ display: "none" }}>
      {elFoto}
    </div>
  );
};

export default EditorFotoUploader;
